import SocialAppContainer from "../../../Components/Applications/SocialApp/SocialAppContainer";

const SocialApp = () => {
  return <SocialAppContainer />;
};

export default SocialApp;
